import { UserPlus } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { ShareApplicationDialog } from './ShareApplicationDialog'

/** In the nav: bring in someone at the business to check the application or finish it. */
export function ShareApplicationButton({ orgId, orgName }: { orgId: string; orgName: string }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button type="button" variant="link" size="sm" className="gap-1.5" onClick={() => setOpen(true)}>
        <UserPlus className="size-4" />
        Share
      </Button>
      {open && <ShareApplicationDialog orgId={orgId} orgName={orgName} onOpenChange={setOpen} />}
    </>
  )
}
